import { nextPageActions } from "./NextPageAction";

const initialState = {
  nextPageData: "",
  nextPageError: "",
  nextPageLoading: false,
};

const nextPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case nextPageActions.NEXT_PAGE_SUCCESS:
      return {
        ...state,
        nextPageData: action.payload,
        nextPageLoading: false,
      };

    case nextPageActions.NEXT_PAGE_ERROR:
      return {
        ...state,
        nextPageError: action.payload,
        nextPageLoading: false,
      };
    case nextPageActions.NEXT_PAGE_LOADING:
      return {
        ...state,
        nextPageLoading: true,
      };

    default:
      return state;
  }
};

export default nextPageReducer;
